import HrTermsTable from 'components/tables/data/hr/HrTermsTable';

export {
  hrCalendarMonth,
  hrTermDateFilterModel,
  hrTermDateServerBounds,
  hrTermIdsFilterModel,
} from 'components/tables/data/hr/HrTermsTable';

/** Route entry for the modular HR terms table/calendar browser. */
export default function HrTermsPage() {
  return <HrTermsTable />;
}
